function setCsrfToken(token) {
  if (!token) return

  let meta = document.querySelector("meta[name=csrf-token]")
  if (!meta) {
    meta = document.createElement("meta")
    meta.setAttribute("name", "csrf-token")
    document.head.appendChild(meta)
  }
  meta.setAttribute("content", token)
}

async function fetchData() {
  const response = await fetch("/sign_up/support", { credentials: "include" })
  if (!response.ok) throw new Error(`${response.status}: ${response.statusText}`)

  const json = await response.json()
  setCsrfToken(json.csrf_token)

  return json
}

async function fetchVendors() {
  let Vue = import(/* webpackChunkName: "vue" */ "vue/dist/vue.runtime.esm")
  let VueI18n = import(/* webpackChunkName: "vue-i18n"  */ "vue-i18n/dist/vue-i18n.esm")

  ;[{ default: Vue }, { default: VueI18n }] = await Promise.all([Vue, VueI18n])

  return {
    Vue,
    VueI18n,
  }
}

async function fetchDependencies() {
  const [data, vendors] = await Promise.all([fetchData(), fetchVendors()])

  return {
    data,
    ...vendors,
  }
}

export default fetchDependencies
